<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">  {{ 'MENU.DASHBOARD.edit_job_title' | translate }} </h3>

<form #jobTitleForm="ngForm" (ngSubmit)="updateJobTitle()" enctype="multipart/form-data">
  <div class="row">
    <!-- Job Title (English) -->
    <!-- <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.job_title_name_en' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_job_title_name_en' | translate }}"
          [(ngModel)]="jobTitle.name_en"
          name="name_en"
          required
          #nameEn="ngModel"
        />
        <div *ngIf="nameEn.invalid && nameEn.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.job_title_name_en_required' | translate }}
        </div>
      </div>
    </div> -->

    <!-- Job Title (Arabic) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.job_title_name_ar' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_job_title_name_ar' | translate }}"
          [(ngModel)]="jobTitle.name"
          name="name"
          required
          #name="ngModel"
        />
        <!-- Validation message -->
        <div *ngIf="name.invalid && name.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.job_title_name_ar_required' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Submit Buttons -->
  <div class="text-start mt-3">
    <button
      type="submit"
      class="btn  px-4" style="background-color: #cca44c !important; color: #fff;"
      [disabled]="jobTitleForm.invalid"
    >
      {{ 'MENU.DASHBOARD.save_changes' | translate }}
    </button>

    <button
      type="button"
      class="btn btn-secondary ms-2 mx-2 px-3" 
      (click)="cancel()"
    >
      {{ 'MENU.DASHBOARD.cancel' | translate }}
    </button>
  </div>
</form>

  </div>
</div>